const sources = {
	teasers_native: 'teasers/native',
	facebook: 'facebook',
	google_adwords: 'google adwords',
	push: 'push',
	seo: 'seo',
	news_feed: 'news feed',
	tik_tok: 'tik tok',
	other: 'other'
};

if (process.env.CPA_ENV === 'rocket') {
	delete sources.tik_tok;
	delete sources.push;
}

const locale = {
	ru: sources,
	en: sources,
	uk: sources,
	de: sources,
	vi: sources,
	th: sources
};

module.exports = {
	enum: sources,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/traffic-sources.js